import Eula from './Eula';
import EulaConnector from './EulaConnector';

const ConnectedComponent = () => <EulaConnector component={Eula} />;

export default ConnectedComponent;
